'use client';

import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { useUserProfileStore } from '@/stores/userProfileStore';
import { useCreditsJourneyStore } from '@/lib/stores/credits-journey-store';

export function useCreditsJourneyAccount() {
  const userId = useAuthStore((state) => state.user?.id ?? null);
  const profile = useUserProfileStore((state) => state.profile);
  const profileLoading = useUserProfileStore((state) => state.isLoading);
  const loadedUserId = useUserProfileStore((state) => state.loadedUserId);
  useEffect(() => {
    useCreditsJourneyStore.getState().activateAccount(userId);
    if (!profileLoading && profile && loadedUserId === userId && profile.user_id === userId) {
      useCreditsJourneyStore.getState().hydrate(profile);
    }
  }, [userId, profile, profileLoading, loadedUserId]);
}
